import { useState, useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, IconButton, DialogContent, Typography, TextField, DialogActions, Alert } from '@mui/material';
import { CloseSquare } from 'iconsax-react';
import Grid from '@mui/material/Grid';
import UploadImgModal from './upload-img-modal';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import styles from './contacts.module.scss';
import Box from '@mui/material/Box/Box';

const LabelModal = ({ show, setShow, uiStore, label, card, cardName, updateModal }) => {
    const { error } = uiStore
    const [loading, setLoading] = useState(false);
    const [showEditName, setShowEditName] = useState('0');
    const [showEditImage, setShowEditImage] = useState(false);
    const [img, setImg] = useState('');
    const [name, setName] = useState('');

    const confirm = async () => {
        setLoading(true);
        await uiStore.updateLabel(card._id, showEditName === '1' ? name : null, showEditImage === '1' ? img : null);
        updateModal();
        setShow(false); 
        setLoading(false);
    };

    useEffect(() => {
        if (label?.name) {
            setShowEditName('1');
        } else {
            setShowEditName('0');
        }

        if (label?.img) {
            setShowEditImage('1');
        } else {
            setShowEditImage('0');
        }

        setName(label?.name);
        setImg(label?.img);

    }, [label, show, card]);

    return (
        <Dialog
            open={show}
            onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
            fullWidth
            maxWidth='md'
        >
            <DialogTitle>
                Edit Contact Label
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {error &&
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                }

                <Grid container>
                    <Grid item xl={6} lg={6}  md={6} sx={{mb: 2, borderBottom: '2px dashed #C7D2E1', paddingBottom: '10px'}}>
                        <Typography color='primary' fontWeight={700}>Contact Label Name</Typography>
                        <RadioGroup sx={{ mt: 3 }} value={showEditName} onChange={(e) => setShowEditName(e.target.value)}>
                            <Box className={styles.contactLabelRadio}>
                                <FormControlLabel
                                    value='0'
                                    control={<Radio />}
                                    label='Use Contact Name'
                                />
                                <Typography fontWeight={600} sx={{ mt: 2, mb: 2, ml: 2 }}>{cardName}</Typography>
                            </Box>
                            <Box className={styles.contactLabelRadio}>
                                <FormControlLabel
                                    value='1'
                                    control={<Radio />}
                                    label='Use Custom Name'
                                />
                                {showEditName === '1' &&
                                    <Box>
                                        <TextField
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            label='Custom Name'
                                            sx={{ mt: 2, mb: 2, ml: 2 }}
                                        />
                                    </Box>
                                }
                            </Box>
                        </RadioGroup>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sx={{mb: 2, borderBottom: '2px dashed #C7D2E1', paddingBottom: '10px'}}>
                        <Typography color='primary' fontWeight={700}>Contact Label Image</Typography>
                        <RadioGroup sx={{ mt: 3 }} value={showEditImage} onChange={(e) => setShowEditImage(e.target.value)}>
                            <Box className={styles.contactLabelRadio}>
                                <FormControlLabel
                                    value='0'
                                    control={<Radio />}
                                    label='Use Contact Image'
                                />
                                <Box>
                                    <img className={styles.contactImg} src={card.image} alt='pic' />
                                </Box>
                            </Box>
                            <Box className={styles.contactLabelRadio}>
                                <FormControlLabel
                                    value='1'
                                    control={<Radio />}
                                    label='Use Custom Image'
                                />
                                {img &&
                                    <Box sx={{ display: 'flex' }}>
                                        <img className={styles.contactImg} src={img} alt='pic' />
                                        <UploadImgModal uiStore={uiStore} setImg={setImg} />
                                    </Box>
                                }
                                {showEditImage === '1' && !img &&
                                    <UploadImgModal uiStore={uiStore} setImg={setImg} />
                                }
                            </Box>
                        </RadioGroup>

                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <LoadingButton loading={loading} onClick={() => setShow(false)} variant="contained" color="lightblue">
                    Cancel
                </LoadingButton>
                <LoadingButton loading={loading} onClick={confirm} variant="contained" color="primary">
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default LabelModal;